import { makeStyles } from 'tss-react/mui';
import MUIAlert, { AlertProps as MUIAlertProps } from '@mui/material/Alert';
import MUIAlertTitle from '@mui/material/AlertTitle';
import { alertIconMapping } from './alert.components';

export type AlertInlineType = MUIAlertProps & {alignIcon?: 'start' | 'center' | 'end'};

export const AlertInline: React.FC<AlertInlineType> = ({ children, title, severity = 'success', alignIcon = 'center', ...props }) => {
  const { classes: alertClasses } = useAlertStyles({ alignIcon });
  const { classes } = useStyles();

  return (
    <MUIAlert {...props} severity={severity} classes={alertClasses} iconMapping={alertIconMapping}>
      <MUIAlertTitle color={severity} className={classes.alertTitle}>{title}</MUIAlertTitle>
      {children}
    </MUIAlert>
  );
};

type AlertStylesProps = {alignIcon: AlertInlineType['alignIcon']};
const useAlertStyles = makeStyles<AlertStylesProps>()((theme, { alignIcon }) => ({
  root: {
    background: 'transparent',
    padding: 0,
  },
  message: {
    padding: 0,
  },
  icon: {
    padding: 0,
    marginRight: '18px',
    display: 'flex',
    alignItems: alignIcon
  }
}));

const useStyles = makeStyles()({
  alertTitle: {
    margin: 0
  }
});
